import eventBus from "@/eventBus";
import router from "@/router";

export default {
    routesMatch(a, b) {
        if (a.name !== b.name) return false;
        if ((a.params?.length ?? 0) !== (b.params?.length ?? 0) || a.params && b.params && [...Object.keys(a.params), ...Object.keys(b.params)].find(key => String(a.params[key]) !== b.params[key])) return false;
        if (a.query && ((a.query?.length ?? 0) !== (b.query?.length ?? 0) || a.query && b.query && [...Object.keys(a.query), ...Object.keys(b.query)].find(key => String(a.query[key]) !== b.query[key]))) return false;
        return true;
    },
    listeners: {},
    subscribe(callback) {
        const newCallback = event => {
            if (event.event === "reloadRoute") {
                if (this.routesMatch(event.data, router.currentRoute.value)) {
                    callback();
                }
            }
        };
        this.listeners[callback] = newCallback;
        eventBus.on("socket:event", newCallback);
    },
    unsubscribe(callback) {
        eventBus.unsubscribe("socket:event", this.listeners[callback]);
    }
}